export const CHART_TOOLTIP_HIDE_DELAY = 250;
export const CHART_TOOLTIP_GAP = 8;
export const CHART_TOOLTIP_MIN_WIDTH = 220;
export const CHART_TOOLTIP_TEST_ID = "hyro-chart-tooltip";
export const CHART_TOOLTIP_CONTENT_TEST_ID = "chart-tooltip-content";
export const SEGMENT_TOOLTIP_OFFSET = [0, -8];
